import OutPutProducts from './OutPutProducts';
export default OutPutProducts;